import { render, staticRenderFns } from "./DetailOrderResearch.vue?vue&type=template&id=52cf6997&scoped=true&"
import script from "./DetailOrderResearch.vue?vue&type=script&lang=js&"
export * from "./DetailOrderResearch.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrderResearch.vue?vue&type=style&index=0&id=52cf6997&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf6997",
  null
  
)

export default component.exports